/** @jsxImportSource @emotion/react */
import {
  ButtonDivider,
  ButtonGroup,
} from '../../../../components/Button';
import {Button} from '@mayo/mayo-ui-gakki';

interface FooterProps {
  onNext?: () => void;
  onPrev?: () => void;
  onSave?: () => void;
  onActive?: () => void;
  onDownloadOrgChart?: () => void;
  showUpdatedTime?: boolean;
  showSaveButton?: boolean;
  showNextButton?: boolean;
  showPrevButton?: boolean;
  showActiveButton?: boolean;
  showDownloadOrgChartButton?: boolean;
  disabledSaveButton?: boolean;
  disabledNextButton?: boolean;
  disabledPrevButton?: boolean;
  disabledActiveButton?: boolean;
  updatedTime?: string;
}

export default function Footer(props: FooterProps) {
  const {
    onNext,
    onPrev,
    onSave,
    onActive,
    onDownloadOrgChart,
    disabledNextButton,
    disabledPrevButton,
    disabledSaveButton,
    disabledActiveButton,
    showUpdatedTime = true,
    showSaveButton,
    showNextButton,
    showPrevButton,
    showActiveButton,
    showDownloadOrgChartButton,
    updatedTime,
  } = props;
  const isShowButtonDivider = showUpdatedTime && (showActiveButton || showNextButton || showPrevButton || showSaveButton || showDownloadOrgChartButton);
  return (
    <footer
      aria-label="footer"
      css={{
        zIndex: 1,
        height: 60,
        backgroundColor: '#fff',
        padding: '9.5px 15px 7.5px 15px',
        display: 'flex',
        justifyContent: 'flex-end',
        alignItems: 'center',
        width: '100vw',
        position: 'fixed',
        bottom: 0,
        left: 0,
        right: 0,
      }}
    >
      {showUpdatedTime && (
        <div
          aria-label="info"
          className="info text-base"
          css={{
            marginRight: 20,
            lineHeight: 2.62,
          }}
        >
          上一次儲存時間：{updatedTime ? updatedTime : '-'}
        </div>
      )}
      {showSaveButton && (
        <Button
        variant={'outline'}
        colorSchema={'primary'}
          disabled={disabledSaveButton}
          onClick={onSave}
          className={'save'}
          aria-label="save"
        >
          儲存進度
        </Button>
      )}
      {isShowButtonDivider && <ButtonDivider />}
      <ButtonGroup>
        {showDownloadOrgChartButton && (
          <Button
          variant={'outline'}
          colorSchema={'primary'}
            onClick={onDownloadOrgChart}
            className={'download'}
            aria-label="download"
          >
            下載組織圖
          </Button>
        )}
        {showPrevButton && (
          <Button
          variant={'outline'}
          colorSchema={'primary'}
            disabled={disabledPrevButton}
            onClick={onPrev}
            className={'pre'}
            aria-label="pre"
          >
            上一步
          </Button>
        )}
        {showNextButton && (
          <Button
          variant={'solid'}
          colorSchema={'primary'}
            disabled={disabledNextButton}
            onClick={onNext}
            className={'next'}
            aria-label="next"
          >
            下一步
          </Button>
        )}
        {showActiveButton && (
          <Button
          variant={'solid'}
          colorSchema={'primary'}
            disabled={disabledActiveButton}
            onClick={onActive}
            className={'active-company'}
            aria-label="active-company"
          >
            啟用專區
          </Button>
        )}
      </ButtonGroup>
    </footer>
  );
}
